import React, { useMemo } from 'react'
import { ToggleStateAction, IActionComponentProps } from '~core/forge.type'
import { Box } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { getSelectedNode } from '~editor/selectors/nodes'
import { library } from '~core/componentLibrary'

interface IProps extends IActionComponentProps {
  action: ToggleStateAction
}

export const ToggleStateActionComponent = ({
  action,
  actions,
  activeActionGesture,
}: IProps) => {
  const selectedNode = useSelector(getSelectedNode)
  const component = useMemo(() => {
    return library.get(selectedNode.type)
  }, [selectedNode.type])

  const statesText = useMemo(() => {
    return Object.values(component?.forge?.states!)
      .map((state) => state?.label)
      .join('/')
  }, [component?.forge?.states])

  return (
    <Box width="100%" display="flex" alignItems="center">
      {`Toggles between ${statesText} states`}
    </Box>
  )
}

export default ToggleStateActionComponent
